import { Field, Area, SelectField, Card } from '@/admin/fields';

const VARIANT_OPTIONS = [
  { value: 'light', label: 'Light (white card)' },
  { value: 'dark', label: 'Dark (black card)' },
  { value: 'green', label: 'Green tint' },
  { value: 'purple', label: 'Purple frame' },
];

export function PerspectiveTab({ content, update }) {
  const pieces = content.perspective.pieces;
  const setPiece = (i, key, v) => update('perspective.pieces', pieces.map((p, idx) => (idx === i ? { ...p, [key]: v } : p)));

  const addPiece = () =>
    update('perspective.pieces', [
      ...pieces,
      {
        id: `piece-${Date.now()}`,
        label: `PIECE // ${String(pieces.length + 1).padStart(2, '0')}`,
        tag: 'New piece',
        line1: 'First line.',
        line2: 'Second line.',
        footnote: 'CONCEPT: ...',
        variant: 'light',
      },
    ]);

  return (
    <div className="space-y-6">
      <Card title="Drop header">
        <Field label="Eyebrow" value={content.perspective.eyebrow} onChange={(v) => update('perspective.eyebrow', v)} testId="edit-perspective-eyebrow" />
        <Field label="Title" value={content.perspective.title} onChange={(v) => update('perspective.title', v)} testId="edit-perspective-title" />
        <Area label="Supporting statement" rows={2} value={content.perspective.support} onChange={(v) => update('perspective.support', v)} testId="edit-perspective-support" />
      </Card>

      {pieces.map((piece, i) => (
        <Card
          key={piece.id}
          title={`${piece.label} — ${piece.tag}`}
          hint="Any letter U in these lines keeps the animated purple ⇄ green transition."
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="Label" value={piece.label} onChange={(v) => setPiece(i, 'label', v)} testId={`edit-piece-label-${i}`} />
            <Field label="Tag" value={piece.tag} onChange={(v) => setPiece(i, 'tag', v)} testId={`edit-piece-tag-${i}`} />
          </div>
          <Field label="Line 1" value={piece.line1} onChange={(v) => setPiece(i, 'line1', v)} testId={`edit-piece-line1-${i}`} />
          <Field label="Line 2" value={piece.line2} onChange={(v) => setPiece(i, 'line2', v)} testId={`edit-piece-line2-${i}`} />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="Footnote" value={piece.footnote} onChange={(v) => setPiece(i, 'footnote', v)} testId={`edit-piece-footnote-${i}`} />
            <SelectField label="Visual treatment" value={piece.variant} onChange={(v) => setPiece(i, 'variant', v)} options={VARIANT_OPTIONS} testId={`edit-piece-variant-${i}`} />
          </div>
          <button
            type="button"
            onClick={() => update('perspective.pieces', pieces.filter((_, idx) => idx !== i))}
            className="text-xs font-mono uppercase text-red-700 hover:underline"
            data-testid={`remove-piece-${i}`}
          >
            Remove this piece
          </button>
        </Card>
      ))}

      <button
        type="button"
        onClick={addPiece}
        className="px-4 py-2 border border-yunti-ink text-xs font-mono uppercase tracking-widest hover:bg-yunti-ink hover:text-white transition-colors"
        data-testid="add-piece"
      >
        + Add piece
      </button>
    </div>
  );
}
